module.exports = __webpack_public_path__ + "static/media/unlock-info-confirmed.2bef7550.svg";